module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "header",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-8"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Islandport Press")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-3"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-9"
  }, [_vm._v("PO Box 10")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-3"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-9"
  }, [_vm._v("Yarmouth, Maine 04096 ")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-3"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-9"
  }, [_vm._v("www.islandportpress.com ")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text ParaOverride-3"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-9"
  }, [_vm._v("info@islandportpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("Copyright © Islandport Press 2019")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("All rights reserved.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("First Islandport Printing, 2019")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("eISBN: 978-1-944762-87-2")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("Library of Congress Card Number: 2019931597")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("Printed in USA.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("Dean L. Lunt, Publisher")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("Book design, Teresa Lagrange")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("“Christmas in a One-Room Schoolhouse,” © May B. Davidson, 2019")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("“An Island Celebration,” © Dean L. Lunt, 2019")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("“Christmas Eve at the Chinese Buffet,” © Maureen Walsh")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("“Snowflakes of Christmas,” © Tristan Noyes, 2019")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("“Unwrapping,” © Shawn Callahan, 2019")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "Character-Style-1 CharOverride-10"
  }, [_vm._v("For all other permissions, please see bibliography.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame _idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("“What happens to me when I cross the Piscataqua and plunge rapidly into Maine…I cannot describe it. I do not ordinarily spy a partridge in a pear tree, or three French hens, but I do have the sensation of having received a gift from a true love.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("—E.B. White")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/icons_for_book1.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-448230b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/All_is_calm_interior_epub2.vue
// module id = 63
// module chunks = 0